export const environment = {
  production: false,
  baseUrl: 'https://app-dev-api.kaparking.com/api/v1',
  // baseUrl: 'https://kaparking3.test/api/v1',
};
